module.exports = __webpack_public_path__ + "img/articleMedicamentsVaccins.c7f5a8fd.png";